import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import {ConfirmDialog} from 'modules/dialog';

class RowItemDanhSachDonViBCTH extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      confirmDialog: false,
      thoiHan: '',
      withTime: false,
      title: ''
    }
  }
  toggleDialog(name, status) {
    this.setState({[name]: status});
  }
  handleLock() {
    let item = this.props.item;
    item.isLock = !this.state.withTime;
    item.thoiHan = this.state.thoiHan;
    this.props.onLock(item);
    this.toggleDialog('confirmDialog', false);
  }
  moBaoCao() {
    this.setState({
      title: `Để mở báo cáo tại đơn vị <span>${this.props.item.donViInfo.ten}<\/span> <br/>vui lòng chọn lại thời hạn báo cáo.`,
      withTime: true,
      confirmDialog: true
    });
  }
  khoaBaoCao() {
    this.setState({
      title: `Bạn có đồng ý khóa báo cáo tại đơn vị <br\/> <span>${this.props.item.donViInfo.ten}<\/span> không?`,
      withTime: false,
      confirmDialog: true
    });
  }
  onChangeDate(date) {
    this.setState({thoiHan: date});
  }
  render() {
    return (
      <tr>
        <ConfirmDialog title={this.state.title} withTime={this.state.withTime} open={this.state.confirmDialog} onChangeDate={this.onChangeDate.bind(this)}
          onClose={this.toggleDialog.bind(this, 'confirmDialog', false)} onSuccess={this.handleLock.bind(this)}/>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='list-items-table'><Link className="txt-underline txt-regular" to={'/thong-ke-bao-cao/bao-cao-tong-hop/chi-tiet-don-vi/'+this.props.item.baoCaoDonViId}>{this.props.item.donViInfo ? this.props.item.donViInfo.ten : ''}</Link></td>
        <td className='txt-left'>{this.props.item.hanBaoCao ? moment(this.props.item.hanBaoCao).format('DD/MM/YYYY') : ''}</td>
        <td className='txt-left'>{this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : ''}</td>
        <td className='txt-left'>{this.props.item.ngayGui ? moment(this.props.item.ngayGui).format('DD/MM/YYYY') : ''}</td>
        <td>
          {
            this.props.item.daKhoa ?
              <Link className="link-action primary" onClick={this.moBaoCao.bind(this)}> <span className="pt-icon-standard pt-icon-unlock" /> Mở báo cáo</Link>
            :
              <Link className="link-action danger" onClick={this.khoaBaoCao.bind(this)}> <span className="pt-icon-standard pt-icon-lock" /> Khóa báo cáo</Link>
          }
        </td>
      </tr>
    );
  }
}

export default RowItemDanhSachDonViBCTH;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemDanhSachDonViBCTH.jsx